export default {"src":"/_next/static/media/esports.190edee9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};